module.exports = __webpack_public_path__ + "img/product-list_m2.3be828dc.png";